<script>
    import jQuery from "jquery";

    let email;
    let username = '';
    $: message = t("Hi,\n\nHere is the garden design I want to share with you. \n\nBest regards,\n")+username;
    let projectid = jQuery('[project_id]').eq(0).attr('project_id');
    let sendInProgress = false;
    let confirmMessage = '';

    $: validEmail = !email || email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
    $: valid = validEmail && message && message.length > 0;
    
    let i18 = {
        "pl": {
            "Send by email": "Wyślij emailem",
            "Recipient email:": "Email odbiorcy:",
            "Message:": "Wiadomość:",
            "Send": "Wyślij",
            "Your message has been sent!": "Twoja wiadomość została wysłana!",
            "Sending...": "Wysyłam...",
            "Hi,\n\nHere is the garden design I want to share with you. \n\nBest regards,\n": "Witaj,\n\nOto projekt ogrodu, który chcę się z Tobą podzielić. \n\nPozdrawiam,\n"
        }
    }

    function t(message) {
        if (lang === "en") return message;
        if (lang === "pl") return i18['pl'][message] ? i18['pl'][message] : message;
    }

    let lang = document.documentElement.getAttribute("lang").toLowerCase() === "pl" ? "pl" : "en";

    export async function showForm() {
        username = (await Promise.resolve(jQuery.get('/api/apiusertoken')))['username'];

        jQuery('#sendByEmailForm').modal();
        jQuery('#sendByEmailForm').on('hidden.bs.modal', () => this.$destroy());
        jQuery('#sendByEmailForm').on('shown.bs.modal',function () {
            document.getElementById('sendByEmailFormEmail').focus()
        });
    }

    function send() {
        if (!email || !valid || sendInProgress) return;
        sendInProgress = true;
        confirmMessage = t('Sending...');
        

        let data = {
            'receipientEmail' : email,
            'message' : message,
            'projectid': projectid
        }

        Promise.resolve(jQuery.post('/api/sendByEmail', data)).then(sent)
    }

    function sent() {
        confirmMessage = t('Your message has been sent!');
        setTimeout(() => {
            jQuery('#sendByEmailForm').modal('hide');
        }, 3000)
    }

</script>

<div id="sendByEmailForm" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title">{t("Send by email")}</h4>
      </div>
      <div class="modal-body sendByEmailFormEmail">
        <div class="form-group">
            <label for="sendByEmailFormEmail">{t("Recipient email:")}</label>
            <input id="sendByEmailFormEmail" type="email" bind:value={email}/>
        </div>
        <div class="form-group sendByEmailFormMessage">
            <label for="sendByEmailFormMessage">{t("Message:")}</label>
            <textarea id="sendByEmailFormMessage" rows="8" bind:value={message}></textarea>
        </div>
        <div class="form-group">
            <div class="help-block">
                {confirmMessage}
            </div>
        </div>        
      </div>
      <div class="modal-footer">
        <button on:click={send} type="button" class="btn btn-primary" class:disabled={!email || !valid || sendInProgress}>{t("Send")}</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->